if (!customElements.get('starry-mobile-header-menu')) {
  customElements.define(
    'starry-mobile-header-menu',
    class starryHeaderMenuMobile extends HTMLElement {
      constructor() {
        super();
      }
      searchTimer = null;
      currentDetailIndex = -1;
      currentDetailType = '';
      currentActiveIndex = 1;
      /** 当前产品详情对应的 section block 序号，与 .ro_mobile_detail_content[data-index] 一致；用于多个 product_menu_new 时避免系列 data-index 重复 */
      currentActiveBlockIndex = null;

      /**
       * 按区块限定 DOM 查询：多个 `product_menu_new` 时，系列级 `data-index` 会在不同区块重复，
       * 必须在对应的 `.ro_mobile_detail_content` 内查找。
       * @param {string|number|null|undefined} blockIndex section.blocks 中的区块序号（字符串）
       * @returns {HTMLElement|null}
       */
      getProductMenuDetailRoot(blockIndex) {
        if (blockIndex == null || blockIndex === '') return null;
        return this.querySelector(`.ro_mobile_detail_content[data-index="${blockIndex}"]`);
      }

      connectedCallback() {
        this.init();
        this.initFilterEvents(); // 初始化筛选事件
        this.initMobileFilterVisibility(); // 初始化移动端筛选容器的可见性
        this.initFilterModal(); // 初始化筛选弹窗
        this.initMobileClearAllEvents(); // 初始化移动端Clear All事件
        this.checkMobileClearAllVisibility(); // 检查移动端Clear All按钮的可见性
        this.updateClearAllButtonStates(); // 初始化Clear All按钮状态
        this.initDynamicHeights(); // 初始化动态高度计算
      }
      init() {
        // 触发器事件注册
        this.querySelector('.ro_mobile_menu_trigger').addEventListener('click', () => {
          this.open();
        });

        //   关闭事件注册
        this.querySelector('.ro_mobile_menu_header .close_button').addEventListener('click', () => {
          this.close();
        });

        //   详情
        const detailDrawerEle = this.querySelector('.ro_mobile_detail_drawer');
        const detailDrawerTitleEle = detailDrawerEle.querySelector('.ro_mobile_detail_title');
        //   详情关闭事件注册
        detailDrawerEle.querySelector('.back_arrow').addEventListener('click', () => {
          this.closeDetail();
        });
        detailDrawerEle.querySelector('.close_button').addEventListener('click', () => {
          this.closeDetail();
          this.close();
        });

        //   菜单事件注册
        const menuList = this.querySelectorAll('.ro_mobile_menu_item');
        menuList.forEach((menuItem) => {
          const menuIndex = menuItem.dataset.index;
          const menuType = menuItem.dataset.type;
          const menuTitle = menuItem.dataset.title;
          if (menuType === 'product_menu_new') {
            const arrowEle = menuItem.querySelector('.menu_arrow');
            menuItem.addEventListener('click', () => {
              const activeState = menuItem.dataset.active;
              const seriesList = menuItem.nextElementSibling;
              
              if (activeState === 'true') {
                menuItem.setAttribute('data-active', false);
              } else {
                // 展开前重新计算高度
                if (seriesList && seriesList.classList.contains('ro_mobile_series_list')) {
                  this.updateSeriesListHeight(seriesList);
                }
                menuItem.setAttribute('data-active', true);
              }
            });
            //   系列项事件注册
            const productSeriesListEle = menuItem.nextElementSibling;
            const productSeriesList = productSeriesListEle.querySelectorAll('.ro_mobile_series_item');
            if (productSeriesList.length) {
              productSeriesList.forEach((productSeriesEle) => {
                productSeriesEle.addEventListener('click', () => {
                  const dataIndex = productSeriesEle.dataset.index;
                  const dataKey = productSeriesEle.dataset.key;
                  const dataTitle = productSeriesEle.dataset.title;
                  detailDrawerTitleEle.innerHTML = dataTitle;

                  const blockDetailRoot = this.getProductMenuDetailRoot(menuIndex);
                  if (!blockDetailRoot) {
                    console.error('[starry-mobile-header-menu] Missing .ro_mobile_detail_content for block', menuIndex);
                    return;
                  }

                  const detailList = blockDetailRoot.querySelectorAll('.ro_mobile_detail_list');
                  detailList.forEach((listItem) => {
                    if (listItem.dataset.active === 'true' && listItem.dataset.index !== dataIndex) {
                      listItem.setAttribute('data-active', false);
                      // 隐藏之前的筛选列表
                      this.handleFilterListActive(listItem.dataset.index, false, menuIndex);
                    }
                    if (listItem.dataset.index === dataIndex) {
                      listItem.setAttribute('data-active', true);
                    }
                  });
                  
                  // 隐藏所有 ro_mobile_detail_filter_function，然后显示对应的
                  const allMobileFilterFunctions = blockDetailRoot.querySelectorAll('.ro_mobile_detail_filter_function');
                  allMobileFilterFunctions.forEach((filterFunction) => {
                    if (filterFunction.dataset.index !== dataIndex) {
                      filterFunction.style.display = 'none';
                      filterFunction.style.opacity = 0;
                      filterFunction.style.transform = 'translateX(-20px)';
                    }
                  });
                  
                  // 隐藏所有 ro_mobile_detail_filter_function_container，然后显示对应的
                  const allMobileFilterContainers = blockDetailRoot.querySelectorAll('.ro_mobile_detail_filter_function_container');
                  allMobileFilterContainers.forEach((filterContainer) => {
                    if (filterContainer.dataset.index !== dataIndex) {
                      filterContainer.style.display = 'none';
                      filterContainer.style.opacity = 0;
                      filterContainer.style.transform = 'translateX(-20px)';
                    }
                  });
                  
                  // 显示对应的 ro_mobile_detail_filter_function
                  const targetMobileFilterFunction = blockDetailRoot.querySelector(`.ro_mobile_detail_filter_function[data-index="${dataIndex}"]`);
                  if (targetMobileFilterFunction) {
                    // 检查对应的筛选列表是否有筛选项（不包括Clear All按钮）
                    const correspondingFilterList = blockDetailRoot.querySelector(`.ro-header-product-menu__filter-list[data-index="${dataIndex}"]`);
                    const filterItemCount = correspondingFilterList ? correspondingFilterList.querySelectorAll('.ro-header-product-menu__filter-item').length : 0;
                    
                    if (filterItemCount > 0) {
                      targetMobileFilterFunction.style.display = 'flex';
                      setTimeout(() => {
                        targetMobileFilterFunction.style.opacity = 1;
                        targetMobileFilterFunction.style.transform = 'translateX(0)';
                      }, 1);
                    } else {
                      targetMobileFilterFunction.style.display = 'none';
                      targetMobileFilterFunction.style.opacity = 0;
                      targetMobileFilterFunction.style.transform = 'translateX(-20px)';
                    }
                  }
                  
                  // 显示对应的 ro_mobile_detail_filter_function_container
                  const targetMobileFilterContainer = blockDetailRoot.querySelector(`.ro_mobile_detail_filter_function_container[data-index="${dataIndex}"]`);
                  if (targetMobileFilterContainer) {
                    // 检查对应的筛选列表是否有筛选项（不包括Clear All按钮）
                    const correspondingFilterList = blockDetailRoot.querySelector(`.ro-header-product-menu__filter-list[data-index="${dataIndex}"]`);
                    const filterItemCount = correspondingFilterList ? correspondingFilterList.querySelectorAll('.ro-header-product-menu__filter-item').length : 0;
                    
                    if (filterItemCount > 0) {
                      targetMobileFilterContainer.style.display = 'flex';
                      setTimeout(() => {
                        targetMobileFilterContainer.style.opacity = 1;
                        targetMobileFilterContainer.style.transform = 'translateX(0)';
                      }, 1);
                    } else {
                      targetMobileFilterContainer.style.display = 'none';
                      targetMobileFilterContainer.style.opacity = 0;
                      targetMobileFilterContainer.style.transform = 'translateX(-20px)';
                    }
                  }
                  
                  // 控制筛选列表的显示/隐藏
                  this.handleFilterListActive(dataIndex, true, menuIndex);
                  this.currentActiveIndex = dataIndex;
                  this.currentActiveBlockIndex = menuIndex;
                  this.currentDetailType = 'product_menu_new';

                  // 顶部引导链接：每条按当前点击系列项所属 block 的文案是否有值控制显示；
                  // 用 inline style.display 切换，避免 hidden 属性被外部 CSS 的 display:flex 覆盖。
                  const helpLbl = (productSeriesEle.dataset.helpLabel || '').trim();
                  const viewLbl = (productSeriesEle.dataset.viewAllLabel || '').trim();

                  const viewAllLink = this.querySelector('.ro_mobile_detail_header_link[data-type="view-all"]');
                  if (viewAllLink) {
                    if (viewLbl) {
                      viewAllLink.style.display = '';
                      viewAllLink.href = productSeriesEle.dataset.linkViewAll || 'javascript:;';
                      const viewAllSpan = viewAllLink.querySelector('span');
                      if (viewAllSpan) {
                        viewAllSpan.textContent = viewLbl;
                      }
                    } else {
                      viewAllLink.style.display = 'none';
                    }
                  }

                  const helpChooseLink = this.querySelector('.ro_mobile_detail_header_link[data-type="help-choose"]');
                  if (helpChooseLink) {
                    if (helpLbl) {
                      helpChooseLink.style.display = '';
                      helpChooseLink.href = productSeriesEle.dataset.linkHelp || 'javascript:;';
                      const helpSpan = helpChooseLink.querySelector('span');
                      if (helpSpan) {
                        helpSpan.textContent = helpLbl;
                      }
                    } else {
                      helpChooseLink.style.display = 'none';
                    }
                  }

                  const headerLinksWrap = this.querySelector('.ro_mobile_detail_header_links');
                  if (headerLinksWrap) {
                    headerLinksWrap.style.display = helpLbl || viewLbl ? '' : 'none';
                  }

                  this.openDetail(menuIndex);
                });
              });
            }
          }
          if (menuType === 'image_text_menu') {
            menuItem.addEventListener('click', () => {
              detailDrawerTitleEle.innerHTML = menuTitle;
              this.currentDetailType = 'image_text_menu';
              const headerLinksWrap = this.querySelector('.ro_mobile_detail_header_links');
              if (headerLinksWrap) {
                headerLinksWrap.style.display = 'none';
              }
              this.openDetail(menuIndex);
            });
          }
          if (menuType === 'text_menu') {
            menuItem.addEventListener('click', () => {
              const activeState = menuItem.dataset.active;
              if (activeState === 'true') {
                menuItem.setAttribute('data-active', false);
              } else {
                menuItem.setAttribute('data-active', true);
              }
            });
          }
          if (menuType === 'There_level_navigation') {
            menuItem.addEventListener('click', () => {
              const activeState = menuItem.dataset.active;
              if (activeState === 'true') {
                menuItem.setAttribute('data-active', false);
              } else {
                menuItem.setAttribute('data-active', true);
              }
            });
          }
          if (menuType === 'country_menu') {
            menuItem.addEventListener('click', () => {
              const activeState = menuItem.dataset.active;
              if (activeState === 'true') {
                menuItem.setAttribute('data-active', false);
              } else {
                menuItem.setAttribute('data-active', true);
              }
            });
          }
        });
      }
      open() {
        this.querySelector('.ro_mobile_menu_drawer').setAttribute('data-active', true);
        document.documentElement.style.overflow = 'hidden';
      }
      close() {
        this.querySelector('.ro_mobile_menu_drawer').setAttribute('data-active', false);
        document.documentElement.style.overflow = 'auto';
      }
      openDetail(index) {
        if (this.currentDetailIndex > 0) {
          this.querySelector(
            `.ro_mobile_detail_drawer .ro_mobile_detail_content[data-index="${this.currentDetailIndex}"]`
          ).setAttribute('data-active', false);
        }
        this.querySelector(
          `.ro_mobile_detail_drawer .ro_mobile_detail_content[data-index="${index}"]`
        ).setAttribute('data-active', true);
        this.querySelector('.ro_mobile_detail_drawer').setAttribute('data-active', true);
        this.querySelector('.ro_mobile_menu_drawer').style.overflow = 'hidden';
        this.currentDetailIndex = index;
      }
      closeDetail() {
        this.querySelector('.ro_mobile_detail_drawer').setAttribute('data-active', false);
        this.querySelector('.ro_mobile_menu_drawer').style.overflow = 'auto';
      }

      handleFilterListActive(index, isActive = false, blockIndex = null) {
        const detailRoot = this.getProductMenuDetailRoot(blockIndex);
        const scope = detailRoot || this;
        const filterListEle = scope.querySelector(`.ro-header-product-menu__filter-list[data-index="${index}"]`);
        if (filterListEle) {
          if (isActive) {
            filterListEle.style.display = 'flex';
            setTimeout(() => {
              filterListEle.style.opacity = 1;
              filterListEle.style.transform = 'translateX(0)';
            }, 1);
            // 重置筛选状态（仅当前产品菜单区块，避免多个 product_menu_new 互相清空）
            this.resetFilters(null, blockIndex);
          } else {
            filterListEle.style.display = 'none';
            filterListEle.style.opacity = 0;
            filterListEle.style.transform = 'translateX(-20px)';
          }
        }

        // 同时控制移动端筛选容器 ro_mobile_detail_filter_function
        const mobileFilterFunction = scope.querySelector(`.ro_mobile_detail_filter_function[data-index="${index}"]`);
        if (mobileFilterFunction) {
          if (isActive) {
            // 检查 ro-header-product-menu__filter-list 中的筛选项数量（不包括Clear All按钮）
            const filterItemCount = filterListEle ? filterListEle.querySelectorAll('.ro-header-product-menu__filter-item').length : 0;
            
            if (filterItemCount > 0) {
              mobileFilterFunction.style.display = 'flex';
              setTimeout(() => {
                mobileFilterFunction.style.opacity = 1;
                mobileFilterFunction.style.transform = 'translateX(0)';
              }, 1);
            } else {
              // 如果筛选项数量 <= 0，隐藏移动端容器
              mobileFilterFunction.style.display = 'none';
              mobileFilterFunction.style.opacity = 0;
              mobileFilterFunction.style.transform = 'translateX(-20px)';
            }
          } else {
            mobileFilterFunction.style.display = 'none';
            mobileFilterFunction.style.opacity = 0;
            mobileFilterFunction.style.transform = 'translateX(-20px)';
          }
        }
      }

      initMobileFilterVisibility() {
        // 检查所有 ro-header-product-menu__filter-list 的筛选项数量，决定对应移动端筛选容器的初始显示状态
        const allFilterLists = this.querySelectorAll('.ro-header-product-menu__filter-list');
        
        allFilterLists.forEach(filterList => {
          const index = filterList.getAttribute('data-index');
          const blockRoot = filterList.closest('.ro_mobile_detail_content');
          // 只统计筛选项，不包括Clear All按钮
          const filterItemCount = filterList.querySelectorAll('.ro-header-product-menu__filter-item').length;
          
          // 处理 ro_mobile_detail_filter_function
          const mobileFilterFunction = blockRoot
            ? blockRoot.querySelector(`.ro_mobile_detail_filter_function[data-index="${index}"]`)
            : this.querySelector(`.ro_mobile_detail_filter_function[data-index="${index}"]`);
          if (mobileFilterFunction) {
            if (filterItemCount <= 0) {
              // 如果筛选项数量 <= 0，隐藏移动端筛选按钮
              mobileFilterFunction.style.display = 'none';
              mobileFilterFunction.style.opacity = 0;
              mobileFilterFunction.style.transform = 'translateX(-20px)';
            } else {
              // 如果有筛选项，显示移动端筛选按钮
              mobileFilterFunction.style.display = 'flex';
              mobileFilterFunction.style.opacity = 1;
              mobileFilterFunction.style.transform = 'translateX(0)';
            }
          }
          
          // 处理 ro_mobile_detail_filter_function_container
          const mobileFilterContainer = blockRoot
            ? blockRoot.querySelector(`.ro_mobile_detail_filter_function_container[data-index="${index}"]`)
            : this.querySelector(`.ro_mobile_detail_filter_function_container[data-index="${index}"]`);
          if (mobileFilterContainer) {
            if (filterItemCount <= 0) {
              // 如果筛选项数量 <= 0，隐藏移动端容器
              mobileFilterContainer.style.display = 'none';
              mobileFilterContainer.style.opacity = 0;
              mobileFilterContainer.style.transform = 'translateX(-20px)';
            } else {
              // 如果有筛选项，显示移动端容器
              mobileFilterContainer.style.display = 'flex';
              mobileFilterContainer.style.opacity = 1;
              mobileFilterContainer.style.transform = 'translateX(0)';
            }
          }
        });
      }

      initFilterModal() {
        // 初始化筛选弹窗事件
        const modal = document.getElementById('mobileFilterModal');
        const backdrop = document.getElementById('mobileFilterBackdrop');
        if (!modal || !backdrop) return;
        
        const closeBtn = modal.querySelector('.ro_mobile_filter_close');
        const overlay = modal.querySelector('.ro_mobile_filter_overlay');
        const clearBtn = modal.querySelector('.ro_mobile_filter_clear');
        const applyBtn = modal.querySelector('.ro_mobile_filter_apply');

        // 为 ro_mobile_detail_filter_function 添加点击事件
        const filterFunctions = this.querySelectorAll('.ro_mobile_detail_filter_function');
        filterFunctions.forEach(filterFunction => {
          filterFunction.addEventListener('click', () => {
            const dataIndex = filterFunction.getAttribute('data-index');
            const blockRoot = filterFunction.closest('.ro_mobile_detail_content');
            const blockIndex = blockRoot ? blockRoot.getAttribute('data-index') : '';
            this.openFilterModal(dataIndex, blockIndex);
          });
        });

        // 关闭弹窗事件
        closeBtn.addEventListener('click', () => this.closeFilterModal());
        overlay.addEventListener('click', () => this.closeFilterModal());
        backdrop.addEventListener('click', () => this.closeFilterModal());

        // 清除所有筛选
        clearBtn.addEventListener('click', () => this.clearAllFilters());

        // 应用筛选
        applyBtn.addEventListener('click', () => this.applyFilters());
      }

      openFilterModal(dataIndex, blockIndex = null) {
        const modal = document.getElementById('mobileFilterModal');
        const filterList = modal.querySelector('.ro_mobile_filter_list');
        
        // 获取对应的筛选列表（按区块限定，避免多个 product_menu_new 系列序号重复）
        const detailRoot = this.getProductMenuDetailRoot(blockIndex);
        const correspondingFilterList = detailRoot
          ? detailRoot.querySelector(`.ro-header-product-menu__filter-list[data-index="${dataIndex}"]`)
          : this.querySelector(`.ro-header-product-menu__filter-list[data-index="${dataIndex}"]`);
        
        if (correspondingFilterList) {
          // 清空弹窗内容
          filterList.innerHTML = '';
          
          // 获取所有筛选项
          const filterItems = correspondingFilterList.querySelectorAll('.ro-header-product-menu__filter-item');
          
          filterItems.forEach(item => {
            // 跳过Clear All按钮
            if (item.classList.contains('ro-header-product-menu__filter-clear-btn')) {
              // 为弹窗中的Clear All按钮添加点击事件
              const modalClearBtn = document.createElement('li');
              modalClearBtn.className = 'ro-header-product-menu__filter-clear-btn';
              
              modalClearBtn.addEventListener('click', () => {
                // 清除弹窗内所有筛选项的激活状态
                const modalFilterItems = filterList.querySelectorAll('.ro-header-product-menu__filter-item');
                modalFilterItems.forEach(modalItem => {
                  modalItem.classList.remove('active');
                });
                // 更新Clear All按钮状态
                this.updateClearAllButtonStates();
              });
              
              filterList.appendChild(modalClearBtn);
              return;
            }
            
            const text = item.querySelector('.ro-header-product-menu__filter-item-text').textContent.trim();
            const iconContainer = item.querySelector('.ro-header-product-menu__filter-item-icon');
            const takeIcon = item.querySelector('.ro-header-product-menu__filter-item-take');
            const takeActiveIcon = item.querySelector('.ro-header-product-menu__filter-item-take-active');
            const isActive = item.classList.contains('active');
            
            // 创建弹窗筛选项，使用与桌面版相同的类名结构
            const modalItem = document.createElement('li');
            modalItem.className = `ro-header-product-menu__filter-item ${isActive ? 'active' : ''}`;
            modalItem.setAttribute('data-filter-text', text);
            
            let iconHtml = '';
            if (iconContainer) {
              const img = iconContainer.querySelector('img');
              if (img) {
                iconHtml = `<div class="ro-header-product-menu__filter-item-icon">
                  <img src="${img.src}" alt="${img.alt}" width="18" height="18">
                </div>`;
              }
            }
            
            // 复制take图标的HTML结构
            let takeIconHtml = '';
            if (takeIcon) {
              takeIconHtml = `<span class="ro-header-product-menu__filter-item-take">
                ${takeIcon.innerHTML}
              </span>`;
            }
            
            let takeActiveIconHtml = '';
            if (takeActiveIcon) {
              takeActiveIconHtml = `<span class="ro-header-product-menu__filter-item-take-active">
                ${takeActiveIcon.innerHTML}
              </span>`;
            }
            
            modalItem.innerHTML = `${iconHtml}<span class="ro-header-product-menu__filter-item-text">${text}</span>${takeIconHtml}${takeActiveIconHtml}`;
            
            // 添加点击事件
            modalItem.addEventListener('click', () => {
              modalItem.classList.toggle('active');
              // 更新Clear All按钮状态
              this.updateClearAllButtonStates();
            });
            
            filterList.appendChild(modalItem);
          });
          
          // 检查弹窗中Clear All按钮的可见性
          const modalClearAllBtn = filterList.querySelector('.ro-header-product-menu__filter-clear-btn');
          const modalFilterItems = filterList.querySelectorAll('.ro-header-product-menu__filter-item');
          
          if (modalClearAllBtn) {
            if (modalFilterItems.length === 0) {
              modalClearAllBtn.style.display = 'none';
            } else {
              modalClearAllBtn.style.display = 'flex';
            }
          }
        }
        
        // 存储当前的系列序号与区块序号（与 .ro_mobile_detail_content[data-index] 一致）
        modal.setAttribute('data-current-index', dataIndex);
        modal.setAttribute('data-current-block-index', blockIndex != null && blockIndex !== '' ? blockIndex : '');
        
        // 显示遮罩
        const backdrop = document.getElementById('mobileFilterBackdrop');
        backdrop.style.display = 'block';
        setTimeout(() => {
          backdrop.classList.add('active');
        }, 10);
        
        // 显示弹窗
        modal.style.display = 'flex';
        setTimeout(() => {
          modal.classList.add('active');
        }, 10);
        
        // 禁止页面滚动
        document.body.style.overflow = 'hidden';
      }

      closeFilterModal() {
        const modal = document.getElementById('mobileFilterModal');
        const backdrop = document.getElementById('mobileFilterBackdrop');
        
        // 隐藏弹窗
        modal.classList.remove('active');
        setTimeout(() => {
          modal.style.display = 'none';
        }, 300);
        
        // 隐藏遮罩
        backdrop.classList.remove('active');
        setTimeout(() => {
          backdrop.style.display = 'none';
        }, 300);
        
        // 恢复页面滚动
        document.body.style.overflow = 'auto';
      }

      clearAllFilters() {
        const modal = document.getElementById('mobileFilterModal');
        const currentIndex = modal.getAttribute('data-current-index');
        const currentBlockIndex = modal.getAttribute('data-current-block-index');
        
        // 清除弹窗内的选择
        const filterItems = modal.querySelectorAll('.ro-header-product-menu__filter-item');
        filterItems.forEach(item => {
          item.classList.remove('active');
        });
        
        // 清除原始筛选列表的状态并显示所有产品
        this.resetFilters(currentIndex, currentBlockIndex);
        
        // 关闭弹窗
        this.closeFilterModal();
      }

      applyFilters() {
        const modal = document.getElementById('mobileFilterModal');
        const activeItems = modal.querySelectorAll('.ro-header-product-menu__filter-item.active');
        const currentIndex = modal.getAttribute('data-current-index');
        const currentBlockIndex = modal.getAttribute('data-current-block-index');
        
        // 获取选中的筛选项文本
        const selectedFilters = Array.from(activeItems).map(item => 
          item.getAttribute('data-filter-text')
        );
        
        // 应用筛选到对应的筛选列表
        const detailRoot = this.getProductMenuDetailRoot(currentBlockIndex);
        const correspondingFilterList = detailRoot
          ? detailRoot.querySelector(`.ro-header-product-menu__filter-list[data-index="${currentIndex}"]`)
          : this.querySelector(`.ro-header-product-menu__filter-list[data-index="${currentIndex}"]`);
        if (correspondingFilterList) {
          const originalItems = correspondingFilterList.querySelectorAll('.ro-header-product-menu__filter-item');
          originalItems.forEach(item => {
            const text = item.querySelector('.ro-header-product-menu__filter-item-text').textContent.trim();
            if (selectedFilters.includes(text)) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });
        }
        
        // 执行产品筛选
        this.filterProducts();
        
        // 更新Clear All按钮状态
        this.updateClearAllButtonStates();
        
        // 关闭弹窗
        this.closeFilterModal();
      }

      initFilterEvents() {
        // 为每个筛选项添加点击事件
        const filterItems = this.querySelectorAll('.ro-header-product-menu__filter-item');
        
        filterItems.forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // 切换筛选项的激活状态
            item.classList.toggle('active');
            
            // 执行筛选逻辑
            this.filterProducts();
            
            // 更新Clear All按钮状态
            this.updateClearAllButtonStates();
          });
        });
      }

      filterProducts() {
        // 获取当前激活的筛选项文本（仅当前区块 + 当前系列下列表，避免多个 product_menu_new 串扰）
        const activeFilters = [];
        const detailRoot = this.getProductMenuDetailRoot(this.currentActiveBlockIndex);
        const currentFilterList = detailRoot
          ? detailRoot.querySelector(`.ro-header-product-menu__filter-list[data-index="${this.currentActiveIndex}"]`)
          : this.querySelector(`.ro-header-product-menu__filter-list[data-index="${this.currentActiveIndex}"]`);
        const activeFilterItems = currentFilterList
          ? currentFilterList.querySelectorAll('.ro-header-product-menu__filter-item.active')
          : this.querySelectorAll('.ro-header-product-menu__filter-item.active');

        activeFilterItems.forEach(item => {
          const filterText = item.querySelector('.ro-header-product-menu__filter-item-text').textContent.trim();
          activeFilters.push(filterText);
        });

        // 获取当前显示的产品列表
        const currentProductList = detailRoot
          ? detailRoot.querySelector(`.ro_mobile_detail_list[data-index="${this.currentActiveIndex}"]`)
          : this.querySelector(`.ro_mobile_detail_list[data-index="${this.currentActiveIndex}"]`);
        if (!currentProductList) return;

        const productItems = currentProductList.querySelectorAll('.ro_mobile_detail_item');
        
        productItems.forEach(product => {
          const dataTarget = product.getAttribute('data-target') || '';
          
          if (activeFilters.length === 0) {
            // 没有激活的筛选项，显示所有产品
            product.style.display = 'flex';
          } else {
            // 如果data-target为空，直接隐藏
            if (dataTarget.trim() === '') {
              product.style.display = 'none';
            } else {
              // 检查产品的 data-target 分段是否与各激活筛选项互含（AND 逻辑）
              const targetArray = dataTarget.split(',').map(item => item.trim());
              const filterMatchesTargetTag = (filter, targetTag) => {
                if (!filter || !targetTag) return false;
                return targetTag.includes(filter) || filter.includes(targetTag);
              };
              const hasAllMatches = activeFilters.every(filter =>
                targetArray.some(targetTag => filterMatchesTargetTag(filter, targetTag))
              );
              
              if (hasAllMatches) {
                product.style.display = 'flex'; // 包含所有筛选项的产品显示
              } else {
                product.style.display = 'none'; // 不包含所有筛选项的产品隐藏
              }
            }
          }
        });
      }



      /**
       * @param {string|null} seriesIndex 系列在菜单内的序号（与 filter-list 的 data-index 一致）；传入时只清空该系列下筛选项
       * @param {string|null} blockIndex section block 序号（与 .ro_mobile_detail_content[data-index] 一致）
       */
      resetFilters(seriesIndex = null, blockIndex = null) {
        const root = blockIndex != null && blockIndex !== '' ? this.getProductMenuDetailRoot(blockIndex) : null;

        if (seriesIndex != null && seriesIndex !== '' && root) {
          const oneList = root.querySelector(`.ro-header-product-menu__filter-list[data-index="${seriesIndex}"]`);
          if (oneList) {
            oneList.querySelectorAll('.ro-header-product-menu__filter-item').forEach((item) => {
              item.classList.remove('active');
            });
          }
        } else if (root) {
          root.querySelectorAll('.ro-header-product-menu__filter-item').forEach((item) => {
            item.classList.remove('active');
          });
        } else {
          this.querySelectorAll('.ro-header-product-menu__filter-item').forEach((item) => {
            item.classList.remove('active');
          });
        }

        const seriesForProducts =
          seriesIndex != null && seriesIndex !== '' ? seriesIndex : this.currentActiveIndex;
        const blockForProducts =
          blockIndex != null && blockIndex !== '' ? blockIndex : this.currentActiveBlockIndex;
        const productRoot =
          blockForProducts != null && blockForProducts !== ''
            ? this.getProductMenuDetailRoot(blockForProducts)
            : null;
        const currentProductList = productRoot
          ? productRoot.querySelector(`.ro_mobile_detail_list[data-index="${seriesForProducts}"]`)
          : this.querySelector(`.ro_mobile_detail_list[data-index="${seriesForProducts}"]`);

        if (currentProductList) {
          currentProductList.querySelectorAll('.ro_mobile_detail_item').forEach((product) => {
            product.style.display = 'flex';
          });
        }

        this.updateClearAllButtonStates();
      }

      initMobileClearAllEvents() {
        // 为移动端每个Clear All按钮添加点击事件
        const clearAllBtns = this.querySelectorAll('.ro-header-product-menu__filter-clear-btn');
        
        clearAllBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const dataIndex = btn.getAttribute('data-index');
            const blockRoot = btn.closest('.ro_mobile_detail_content');
            const blockIndex = blockRoot ? blockRoot.getAttribute('data-index') : null;
            this.clearMobileFiltersForIndex(dataIndex, blockIndex);
          });
        });
      }

      clearMobileFiltersForIndex(index, blockIndex = null) {
        // 清除指定索引的移动端筛选项
        const detailRoot = this.getProductMenuDetailRoot(blockIndex);
        const scope = detailRoot || this;
        const filterList = scope.querySelector(`.ro-header-product-menu__filter-list[data-index="${index}"]`);
        if (filterList) {
          const filterItems = filterList.querySelectorAll('.ro-header-product-menu__filter-item');
          filterItems.forEach((item) => {
            item.classList.remove('active');
          });
        }

        // 显示该索引下的所有移动端产品
        const productList = scope.querySelector(`.ro_mobile_detail_list[data-index="${index}"]`);
        if (productList) {
          const productItems = productList.querySelectorAll('.ro_mobile_detail_item');
          productItems.forEach((product) => {
            product.style.display = 'flex';
          });
        }
        
        // 更新Clear All按钮状态
        this.updateClearAllButtonStates();
      }

      checkMobileClearAllVisibility() {
        // 检查每个移动端筛选列表的Clear All按钮可见性
        const filterLists = this.querySelectorAll('.ro-header-product-menu__filter-list');
        
        filterLists.forEach((filterList) => {
          const clearAllBtn = filterList.querySelector('.ro-header-product-menu__filter-clear-btn');
          const filterItems = filterList.querySelectorAll('.ro-header-product-menu__filter-item');
          const blockRoot = filterList.closest('.ro_mobile_detail_content');
          
          if (clearAllBtn) {
            // 如果没有筛选项，隐藏Clear All按钮
            if (filterItems.length === 0) {
              clearAllBtn.style.display = 'none';
            } else {
              clearAllBtn.style.display = 'flex';
            }
          }
          
          // 同时检查对应的移动端筛选按钮可见性
          const index = filterList.getAttribute('data-index');
          const mobileFilterFunction = blockRoot
            ? blockRoot.querySelector(`.ro_mobile_detail_filter_function[data-index="${index}"]`)
            : this.querySelector(`.ro_mobile_detail_filter_function[data-index="${index}"]`);
          const mobileFilterContainer = blockRoot
            ? blockRoot.querySelector(`.ro_mobile_detail_filter_function_container[data-index="${index}"]`)
            : this.querySelector(`.ro_mobile_detail_filter_function_container[data-index="${index}"]`);
          
          if (filterItems.length === 0) {
            // 没有筛选项时，隐藏移动端筛选按钮
            if (mobileFilterFunction) {
              mobileFilterFunction.style.display = 'none';
              mobileFilterFunction.style.opacity = 0;
              mobileFilterFunction.style.transform = 'translateX(-20px)';
            }
            if (mobileFilterContainer) {
              mobileFilterContainer.style.display = 'none';
              mobileFilterContainer.style.opacity = 0;
              mobileFilterContainer.style.transform = 'translateX(-20px)';
            }
          }
        });
      }

      updateClearAllButtonStates() {
        // 更新所有Clear All按钮的状态
        const filterLists = this.querySelectorAll('.ro-header-product-menu__filter-list');
        
        filterLists.forEach((filterList) => {
          const clearAllBtn = filterList.querySelector('.ro-header-product-menu__filter-clear-btn');
          const activeFilterItems = filterList.querySelectorAll('.ro-header-product-menu__filter-item.active');
          
          if (clearAllBtn) {
            if (activeFilterItems.length > 0) {
              clearAllBtn.classList.add('has-active-filters');
            } else {
              clearAllBtn.classList.remove('has-active-filters');
            }
          }
        });
        
        // 同时更新弹窗中的Clear All按钮状态
        const modal = document.getElementById('mobileFilterModal');
        if (modal) {
          const modalClearAllBtn = modal.querySelector('.ro-header-product-menu__filter-clear-btn');
          const modalActiveFilterItems = modal.querySelectorAll('.ro-header-product-menu__filter-item.active');
          
          if (modalClearAllBtn) {
            if (modalActiveFilterItems.length > 0) {
              modalClearAllBtn.classList.add('has-active-filters');
            } else {
              modalClearAllBtn.classList.remove('has-active-filters');
            }
          }
        }
      }
      
      // 初始化动态高度计算
      initDynamicHeights() {
        this.calculateSeriesListHeights();
      }
      
      // 计算并设置 ro_mobile_series_list 的动态高度
      calculateSeriesListHeights() {
        const seriesLists = this.querySelectorAll('.ro_mobile_series_list');
        
        seriesLists.forEach((seriesList) => {
          // 检查当前元素是否同时具有 starry_moblie_series_three_container 类
          if (seriesList.classList.contains('starry_moblie_series_three_container')) {
            // 只对具有 starry_moblie_series_three_container 类的元素进行处理

            const calculatedHeight = this.calculateSeriesItemsHeight(seriesList);
            
            // 设置动态高度
            seriesList.style.setProperty('--dynamic-max-height', `${calculatedHeight}px`);
          }
        });
      }
      
      // 计算series_item_three元素的总高度
      calculateSeriesItemsHeight(seriesList) {
        // 找到当前 seriesList 下所有的 series_item_three 元素
        const seriesItems = seriesList.querySelectorAll('.series_item_three');
        
        let totalHeight = 0;
        
        seriesItems.forEach((item, index) => {
          // 获取每个 series_item_three 的实际高度（包括 margin, padding, border）
          const itemStyle = window.getComputedStyle(item);
          const itemHeight = item.offsetHeight;
          const marginTop = parseFloat(itemStyle.marginTop) || 0;
          const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
          
          const fullItemHeight = itemHeight + marginTop + marginBottom;
          totalHeight += fullItemHeight;
          
         
        });
        
        return totalHeight;
      }
      
      // 更新特定系列列表的高度
      updateSeriesListHeight(seriesList) {
        if (!seriesList) return;
        
        // 临时显示元素以获取真实高度
        const originalDisplay = seriesList.style.display;
        const originalVisibility = seriesList.style.visibility;
        const originalPosition = seriesList.style.position;
        const originalMaxHeight = seriesList.style.maxHeight;
        
        // 设置为可见但不占据空间
        seriesList.style.display = 'block';
        seriesList.style.visibility = 'hidden';
        seriesList.style.position = 'absolute';
        seriesList.style.maxHeight = 'none';
        seriesList.style.opacity = '1';
        
        // 获取内容的实际高度
        const scrollHeight = seriesList.scrollHeight;
        
        // 恢复原始样式
        seriesList.style.display = originalDisplay;
        seriesList.style.visibility = originalVisibility;
        seriesList.style.position = originalPosition;
        seriesList.style.maxHeight = originalMaxHeight;
        
        // 设置动态高度
        seriesList.style.setProperty('--dynamic-max-height', `${scrollHeight}px`);
      }
    }
  );
}
